module.exports = __webpack_public_path__ + "img/VERS1.3bebb90f.png";